import { Input, Popconfirm, Space } from "antd";
import dayjs from "dayjs";
import React, { useState, useEffect, createRef } from "react";
import { useNavigate } from "react-router-dom";
import { updateJob } from "@/services/common";
import { replaceStr } from "@/config/func";

const Component = (props: any) => {
  const { item, userInfo, del_confirm, loadData } = props
  const [isEdit, setIsEdit] = useState(false)
  const history = useNavigate();
  const ref: any = createRef();
  const ref2: any = createRef();
  const status = (s: string) => {
    if (s === "done") {
      return <span style={{ color: "#14EB64" }}>已完成</span>;
    } else if (s === "pending") {
      return <span style={{ color: "#14EB64" }}>排队中</span>;
    } else if (s === "running") {
      return <span style={{ color: "#14EB64" }}>计算中</span>;
    } else {
      return <span style={{ color: "red" }}>计算错误</span>;
    }
  };

  const changeContent = (id: any) => {
    const s: any = {}
    Object.keys(item).map((o: any) => {
      if (o !== 'id' &&
        o !== 'created_at' &&
        o !== 'updated_at'
      ) {
        s[o] = item[o]
      }
    })
    // console.log(ref2.current.value);
    updateJob(id, {
      ...s,
      name: ref.current.value,
      // description: ref2.current.value
      description: ''
    }, userInfo.access_token).then((r) => {
      loadData();
    })
  }
  return (
    <tr>
      <td
        className="tabelImg"
        style={{ textAlign: "left" }}
      >
        {isEdit
          ?
          <input className="nameInput2" type="text" ref={ref} defaultValue={item.name} />
          : <div className="itemName" style={{ color: "orange" }} onClick={() => history(`/project/${item.project.id}/flow/${item.flow.id}?j=${item.id}`)}>{item.name}</div>}
      </td>
      {/* <td className="itemDesc">
        {isEdit ?
          <textarea ref={ref2} className="nameInput2" defaultValue={item.description} />
          :
          <div dangerouslySetInnerHTML={{ __html: `${replaceStr(item.description ? item.description : '')}` }} />
        }
      </td> */}
      {item.project ?
        <>
          <td className="itemTaskTotal" style={{ color: '#424241' }} onClick={() => history(`/project/home/view?k=${item.project.id}`)}>{item.project.name}</td>
          <td className="itemTaskTotal" style={{ color: '#424241' }} onClick={() => history(`/project/${item.project.id}/flow/${item.flow.id}?j=${item.id}`)}>{item.flow.name}</td>
        </>
        :
        <>
          <td></td>
          <td></td>
        </>
      }
      {/* <td className="itemTaskTotal" onClick={()=>history(`/projects/view?k=${item.project.id}`)}>{item.project.name}</td> */}

      <td className="itemFlowTotal">{status(item.status)}</td>
      <td>{dayjs(item.date).format("YYYY-MM-DD")}</td>
      <td>{userInfo.username}</td>
      <td className="item_action_td">
        <div className="item_action_c">
          {isEdit ?
            <Space>
              <div
                className='button edit'
                onClick={() => changeContent(item.id)}

              ><div className='icon ok'></div></div>
              <div
                className='button cancle'
                onClick={() => {
                  setIsEdit(false)
                }}><div className='icon cancel'></div></div>
            </Space>
            :
            <div className="item_action">
              {/* {item.project ?
                <div
                  className="sp_icon sp_icon_view"
                  title="查看"
                  onClick={() =>
                    history(`/project/${item.project.id}/flow/${item.flow.id}?j=${item.id}`)
                  }
                />
                : <div
                  className="sp_icon sp_icon_view"
                  title="查看"
                />} */}

              <div className="sp_icon sp_icon_edit" title="修改" onClick={() => setIsEdit(true)} />
              <Popconfirm
                title="确定删除该项目？"
                description="删除后不可恢复！"
                onConfirm={() => del_confirm(item.id)}
                // onCancel={cancel}
                okText="是"
                cancelText="否"
              >
                <div className="sp_icon sp_icon_delete" title="删除" />
              </Popconfirm>
            </div>
          }

        </div>
      </td>
    </tr>
  );
};

export default Component;
